import { render, staticRenderFns } from "./SelectElderly.vue?vue&type=template&id=2096632a&"
import script from "./SelectElderly.vue?vue&type=script&lang=js&"
export * from "./SelectElderly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports